import React, { useState, useEffect } from 'react';
import { useTelegram } from './TelegramProvider';

const APP_LINK_BASE = 'https://t.me/LittleApe_Token_Bot?startapp=ref_';
const REFERRAL_KEY = 'lilape_referral_stats';

export const ReferralPage = () => {
    const { user, tg } = useTelegram();
    const [copied, setCopied] = useState(false);
    const [stats, setStats] = useState({ referralCount: 0, bonusSpinsEarned: 0 });

    const userId = user?.id;
    const referralLink = userId ? `${APP_LINK_BASE}${userId}` : null;

    useEffect(() => {
        try {
            const stored = localStorage.getItem(REFERRAL_KEY);
            if (stored) setStats(JSON.parse(stored));
        } catch {}
    }, []);

    const handleCopy = async () => {
        if (!referralLink) return;
        try {
            await navigator.clipboard.writeText(referralLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // fallback for Telegram WebView
            const el = document.createElement('textarea');
            el.value = referralLink;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    const handleShare = () => {
        if (!referralLink || !tg) return;
        const shareText = `🦍 Join me on LILAPE — the wildest meme coin on TON!\n\n🎰 Play Slot Machine & Crash Game\n💎 Stake for up to 50% APY\n🎁 Get +10 FREE spins when you join!\n\n👇 Open Mini App:`;
        tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=${encodeURIComponent(shareText)}`);
    };

    return (
        <div>
            <div className="page-header">
                <div className="page-header-icon" style={{ background: 'linear-gradient(135deg,#8b5cf6,#ec4899)' }}>👥</div>
                <div>
                    <div className="page-title">Invite Friends</div>
                    <div className="page-subtitle">Earn bonus spins together</div>
                </div>
            </div>

            {/* Reward explanation */}
            <div style={{ margin: '0 16px 16px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div className="card" style={{ padding: 16, textAlign: 'center' }}>
                    <div style={{ fontSize: 32, marginBottom: 6 }}>🎰</div>
                    <div style={{ fontSize: 22, fontWeight: 900, color: 'var(--gold)' }}>+5</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>bonus spins<br />for you per invite</div>
                </div>
                <div className="card" style={{ padding: 16, textAlign: 'center' }}>
                    <div style={{ fontSize: 32, marginBottom: 6 }}>🦍</div>
                    <div style={{ fontSize: 22, fontWeight: 900, color: '#34d399' }}>+10</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>bonus spins<br />for your friend</div>
                </div>
            </div>

            {/* Your stats */}
            <div style={{ margin: '0 16px 16px', padding: 16, borderRadius: 'var(--radius-md)', background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.25)' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 12 }}>📊 Your Referral Stats</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 26, fontWeight: 900, color: '#a78bfa' }}>{stats.referralCount}</div>
                        <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Friends invited</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 26, fontWeight: 900, color: 'var(--gold)' }}>{stats.bonusSpinsEarned}</div>
                        <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Bonus spins earned</div>
                    </div>
                </div>
            </div>

            {/* Invite link */}
            <div style={{ margin: '0 16px 16px' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8 }}>🔗 Your Invite Link</div>
                {referralLink ? (
                    <>
                        <div style={{
                            padding: '10px 14px',
                            borderRadius: 'var(--radius-sm)',
                            background: 'var(--bg-secondary)',
                            border: '1px solid rgba(245,158,11,0.3)',
                            fontSize: 11,
                            color: 'var(--text-secondary)',
                            fontFamily: 'monospace',
                            wordBreak: 'break-all',
                            marginBottom: 10,
                        }}>
                            {referralLink}
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                            <button
                                onClick={handleCopy}
                                style={{
                                    padding: '12px',
                                    borderRadius: 'var(--radius-md)',
                                    background: copied ? 'rgba(52,211,153,0.15)' : 'rgba(245,158,11,0.12)',
                                    border: `1px solid ${copied ? 'rgba(52,211,153,0.4)' : 'rgba(245,158,11,0.3)'}`,
                                    color: copied ? '#34d399' : 'var(--gold)',
                                    fontSize: 13,
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                }}
                            >
                                {copied ? '✅ Copied!' : '📋 Copy Link'}
                            </button>

                            <button
                                onClick={handleShare}
                                style={{
                                    padding: '12px',
                                    borderRadius: 'var(--radius-md)',
                                    background: 'linear-gradient(135deg,rgba(139,92,246,0.2),rgba(236,72,153,0.2))',
                                    border: '1px solid rgba(139,92,246,0.35)',
                                    color: '#a78bfa',
                                    fontSize: 13,
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                }}
                            >
                                📤 Share
                            </button>
                        </div>
                    </>
                ) : (
                    <div style={{ color: 'var(--text-muted)', fontSize: 13, textAlign: 'center', padding: 16 }}>
                        Open via Telegram to get your invite link
                    </div>
                )}
            </div>

            {/* How it works */}
            <div style={{ margin: '0 16px 24px', padding: 16, borderRadius: 'var(--radius-md)', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 10 }}>💡 How it works</div>
                {[
                    { n: '1', text: 'Share your invite link with friends' },
                    { n: '2', text: 'Friend opens the Mini App via your link' },
                    { n: '3', text: 'You both get bonus spins instantly' },
                    { n: '4', text: 'No limit — invite as many as you want!' },
                ].map(step => (
                    <div key={step.n} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                        <div style={{
                            width: 22, height: 22, borderRadius: '50%',
                            background: 'linear-gradient(135deg,#f59e0b,#ef4444)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 11, fontWeight: 900, color: '#000', flexShrink: 0,
                        }}>{step.n}</div>
                        <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{step.text}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
